import { PluginType } from '@deephaven/plugin';
import WidgetLoaderPlugin from "./WidgetLoaderPlugin.js";
var WidgetLoaderPluginConfig = {
  name: 'WidgetLoaderPlugin',
  type: PluginType.DASHBOARD_PLUGIN,
  component: WidgetLoaderPlugin
};
export default WidgetLoaderPluginConfig;
//# sourceMappingURL=WidgetLoaderPluginConfig.js.map